import AddPrescriberPracticePage from './AddPrescriberPracticePage'

export default AddPrescriberPracticePage
